abstract class Tab extends SelectableWidget {
    tabGroup: TabGroup;
    headerContainer: JQuery;
    contentContainer: JQuery;

    protected constructor(identifier: string, contents: string, container: JQuery, controller: Controller, widgetFactory: WidgetFactory, tabGroup: TabGroup, mode: string) {
        super(identifier, Action.SELECTED, controller, container, mode);

        this.tabGroup = tabGroup;
        this.headerContainer = null;
        this.contentContainer = null;

        this.initHTML(container);
        this.initChildren(this.contentContainer,widgetFactory);
        //this.initMiniMap(); // TODO: FUTURE WORK
        this.initBehavior();
    }

    /**
     * Replace the HTML in this.container with new HTML
     * @param oldContainer the old container
     */
    abstract initHTML(oldContainer: JQuery);

    //abstract initMiniMap();

    initChildren(container: JQuery, widgetFactory: WidgetFactory) {
        this.children = widgetFactory.initialiseWidgets(container, this.controller);
    }

    /**
     * To be called after replacing the HTML and setting this.container
     */
    initBehavior() {
        let oThis = this;

        this.headerContainer.click(function () {
            if(oThis.isEnabled()) {
                oThis.controller.processEvent(new GUIEvent(oThis.identifier, Action.SELECTED, Effect.EXECUTE));
                //oThis.headerContainer.trigger('mouseenter'); // Update feedforward
            }
        });

        this.headerContainer.hover(function() {
            if(oThis.isEnabled()) {
                oThis.controller.processEvent(new GUIEvent(oThis.identifier, Action.SELECTED, Effect.START_PREVIEW));
            }
        }, function () {
            if (oThis.isEnabled()) {
                oThis.controller.processEvent(new GUIEvent(oThis.identifier, Action.SELECTED, Effect.STOP_PREVIEW));
            }
        });

        this.contentContainer.scroll(function() { //.box is the class of the div
            if(oThis.isEnabled()) {
                oThis.controller.processEvent(new GUIEvent(oThis.identifier, Action.SCROLLED, Effect.EXECUTE));
            }
        });
    }

    /**
     * Redirect event down to the responsible widget
     * @param event
     * @param windowState
     * @post the windowState will be updated
     */
    handleEvent(event, windowState) {
        if(event.identifier === this.identifier && event.action === Action.SELECTED) {
            windowState.getWidgetState(this.tabGroup.identifier).selectTab(this.identifier);
        }

        for(let widgetName in this.children) {
            this.children[widgetName].handleEvent(event, windowState);
        }
    }

    newState() {
        return new TabState();
    }

    setState(tabState) {
        this.setEnabled(tabState.enabled);
        this.setSelected(tabState.selected);
        this.setChildrenStates(tabState);

        let numAcknowledgementsRequired: number = tabState.getNumRemainingAcknowledgements();

        if(numAcknowledgementsRequired > 0) {
            this.setNumAcknowledgementsRequired(numAcknowledgementsRequired);
        } else {
            this.removeAcknowledgementsRequired();
        }
    }

    getState() {
        var result = new TabState();

        result.enabled = this.isEnabled();
        result.selected = this.isSelected();
        result.childrenStates = this.getChildrenStates();

        return result;
    }

    previewState(tabState: TabState, timeRatioLeft: number) {
        this.previewEnabled(tabState.enabled, timeRatioLeft);
        this.previewSelected(tabState.selected, timeRatioLeft);
        this.previewChildrenStates(tabState, timeRatioLeft);
    }

    removePreviewState() {
        this.removePreviewEnabled();
        this.removePreviewSelected();
        this.removePreviewChildrenStates();
    }

    abstract setNumAcknowledgementsRequired(numAcknowledgementsRequired: number);
    abstract removeAcknowledgementsRequired();
}